import * as React from 'react';
import { Typography, Menu, MenuItem } from '@mui/material';
import Link from 'components/Link';

import { getColor } from 'utils/theme';

import { remCalc } from '../utils/theme';

const Dropdown = ({open, links, anchor, onClose, anchorOrigin, transformOrigin}) => {
	const overrides = {
		'.MuiPopover-paper': {
			background: getColor('blue', 600),
			color: getColor('white', 100),
			boxShadow: 'none',
			borderRadius: 0,
			borderBottomRightRadius: remCalc(100),
			border: 'none',
			top: '0px !important',
			left: '0px !important',
			width: '100%',
			maxWidth: '100%',
			paddingTop: remCalc(182),
			paddingBottom: remCalc(75),
			// padding: '182px 50px 20px 50px',
		},
		'.MuiMenu-list': {
			padding: '0',
			margin: '0',
			'.MuiMenuItem-root': {
				justifyContent: 'center',
				marginBottom: '35px',
				a: {
					textDecoration: 'none',
				}
			},
		},
	};

	const menuItemStyle = {
		marginBottom: '16px',

	}

	return (
		<Menu sx={overrides} open={open} onClose={onClose} anchorEl={anchor} anchorOrigin={anchorOrigin} transformOrigin={transformOrigin}>
			{links.map((item, index) => <MenuItem key={index} sx={menuItemStyle}><Link href={item.href} onClick={onClose}><Typography variant="mobileNav">{item.text}</Typography></Link></MenuItem>)}
		</Menu>
	)
}

export default Dropdown;